import { render, staticRenderFns } from "./WineSweetness.vue?vue&type=template&id=58a03c54"
import script from "./WineSweetness.vue?vue&type=script&lang=ts"
export * from "./WineSweetness.vue?vue&type=script&lang=ts"
import style0 from "./WineSweetness.vue?vue&type=style&index=0&id=58a03c54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports